/* eslint-disable import/no-cycle */
import React from "react";
import { useLocation } from "react-router-dom";
import { Transition } from "react-transition-group";


import styles from "./styles.module.scss";

function MainMenu(props) {
  const duration = 500;
  const location = useLocation();
  const defaultStyle = {
    transition: `height ${duration}ms ease-in-out`,
    height: "0px",
    position: "fixed",
    width: "100%",
    bottom: "-200px",
    left: "0px",
    zIndex: 200,
  };

  const transitionStyles = {
    entering: { height: "calc(100% - 60px)", bottom: "0px" },
    entered: { height: "calc(100% - 60px)", bottom: "0px" },
    exiting: { height: "0px", bottom: "0px" },
    exited: { height: "0px", bottom: "-200px" },
  };

  const getUrl = (url) => {
    url === location.pathname && props.setMainActive(false);
  };

  const isProfile = location.pathname.indexOf("app") > -1;

  return (
    <>
      <Transition in={props.in} timeout={duration}>
        {(state) => (
          <div
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
          >
            <div
              className={`${styles["mobile-nav-container"]} ${styles["profile-mobile-nav"]} ${styles["upper-column"]}`}
              id="mobile-nav"
            >
              <a className={styles["mobile-tab-names"]} href="/products">
                Products
              </a>
              <a className={styles["indented-menu-link"]} href="/product/protein/">
                Protein
              </a>
              <a className={styles["indented-menu-link"]} href="/product/hydration/">
                Hydration
              </a>
              <a className={styles["indented-menu-link"]} href="/product/preworkout/">
                Pre-Workout
              </a>
              <a className={styles["indented-menu-link"]} href="/product/boosts/">
                Performance Boosts
              </a>

              <a className={styles["mobile-tab-names"]} href="/ingredients/">
                Ingredients
              </a>
              <a className={styles["mobile-tab-names"]} href="/science/">
                Science
              </a>
              <a className={styles["mobile-tab-names"]} href="/mission/">
                About Us
              </a>

              <a className={styles["secondary-menu-link"]} href="/logout">
                Sign out
              </a>
            </div>
          </div>
        )}
      </Transition>
    </>
  );
}

export default MainMenu;
